/*
 * @Author: zhangjingqing
 * @Date: 2022-05-03 21:42:50
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-05-07 23:37:32
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\api\comb.js
 */
import { postAction } from "./http/manage";
const URL = process.env.VUE_APP_API_PREFIX;

// 新建风险组合规则
const createRiskComb = (params) =>
  postAction(URL + "/comb-index/create-riskComb", params);
// 删除风险组合规则
const deleteRiskComb = (params) =>
  postAction(URL + "/comb-index/delete-riskComb?id=" + params.id);
// 查询风险规则
const getRisk = (params) => postAction(URL + "/comb-index/get-risk", params);
// 查询组合条件
const getRiskComb = (params) =>
  postAction(URL + "/comb-index/get-riskComb", params);
// 修改风险组合规则
const updateRiskComb = (params) =>
  postAction(URL + "/comb-index/update-riskComb", params);

export { createRiskComb, deleteRiskComb, getRisk, getRiskComb, updateRiskComb };
